import call from "../../../../service/http";
import directorConstants from "./directorConstants";
import SearchConstants from "../../../search/SearchConstants";
import router from "../../../../router";

export default {
  namespaced: true,
  state: {
    directors: [],
    searchResults: [],
    loadingSearch: false,
  },
  mutations: {
    SET_Directors: (state, payload) => {
      state.directors = payload;
    },
    SET_SEARCH_RESULTS: (state, payload) => {
      state.searchResults = payload;
    },
    SET_LOADING_SEARCH: (state, payload) => {
      state.loadingSearch = payload;
    },
  },
  getters: {
    directors: (state) => state.directors,
    searchResults: (state) => state.searchResults,
    loadingSearch: (state) => state.loadingSearch,
  },
  actions: {
    searchMembers: ({ commit }, term) => {
      if (!term) {
        commit("SET_SEARCH_RESULTS", []);
        return;
      }
      commit("SET_LOADING_SEARCH", true);
      const query = {
        term: btoa(term.trim()),
        limit: 10,
        select: true,
      };
      call("get", SearchConstants.search(query))
        .then((res) => {
          commit("SET_SEARCH_RESULTS", res.data.data.data);
          commit("SET_LOADING_SEARCH", false);
        })
        .catch(() => {
          commit("SET_LOADING_SEARCH", false);
        });
    },

    getDirectors: ({ commit }, params) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_ALERT", null);
      call("get", directorConstants.directors, null, {
        params,
      })
        .then((res) => {
          commit("SET_Directors", res.data.data);
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },

    addDirector: ({ commit, dispatch }, data) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_ALERT", null);
      call("post", directorConstants.directors, data)
        .then(() => {
          const currentRoute = router.currentRoute;
          dispatch("getDirectors", {
            ProfileID: currentRoute?.params?.firmCode,
          });
          Event.$emit("application-checklist");
        })
        .catch(() => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: "Professional Registration Number not found",
          });
        });
    },

    removeDirector: ({ commit, dispatch }, payload) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_ALERT", null);
      call("post", directorConstants.remove, payload)
        .then(() => {
          dispatch("getDirectors");
          Event.$emit("application-checklist");
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },

    updateDirector: ({ dispatch, commit }, payload) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_ALERT", null);
      call("post", directorConstants.update, payload)
        .then(() => {
          dispatch("getDirectors");
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },
  },
};
